import { RawFile } from "../../models/RawFile";

// Constants
export const ADD_SITE_PHOTO = "ADD_SITE_PHOTO";
export const DELETE_SITE_PHOTO = "DELETE_SITE_PHOTO";

// Action Types
interface AddSitePhotoAction {
    type: typeof ADD_SITE_PHOTO;
    sitePhotoFileKey: string;
    photoFile: RawFile;
    createdById: string;
    comments: string;
}

interface DeleteSitePhotoAction {
    type: typeof DELETE_SITE_PHOTO;
    sitePhotoId: string;
}

export type PermitSitePhotosTabActionTypes = AddSitePhotoAction | DeleteSitePhotoAction;
